import {baseConfig} from '../helpers/baseConfig'

export const amazonPayConfig = (props) => {
    return {
        ...baseConfig(props),
        showPayButton: true,
        productType: 'PayAndShip',
        checkoutMode: 'ProcessOrder',
        returnUrl:
            props.returnUrl || `${window.location.origin}${window.location.pathname}/redirect`,
        onClick: async (resolve, reject) => {
            try {
                const [onBillingSubmit] = props.beforeSubmit
                await onBillingSubmit()
                resolve()
            } catch (err) {
                reject(err)
            }
        }
    }
}
